<template>
  <RankDivisionPicker
    :type="'currentRank'"
    item-key="placementBoost"
    :title="$t('calculators_common.previous_season_rank')"
    class="full-width"
    :show-server="true"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_games')"
    :description="$t('calculators_common.select_number_of_games')"
    type="games-other"
    :max="5"
  />
  <option-picker />
  <roles-picker />
  <ChampionsPicker />
</template>

<script setup>
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "./pickers/RolesPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import RangePicker from "../commonpickers/RangePicker.vue";
import { onMounted, watch } from "vue";
const {
  setDetails,
  setPlatform,
  setServer,
  setGameAndPack,
  clearCheckout,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack } = useGameStore();
const handleDetails = () => {
  clearCheckout();

  setDetails({
    currentDivision: 5,
    currentDivisionTitle: "IV",
    currentRank: 2,
    currentRankTitle: "Bronze",
    numberOfGames: 1,
  });

  setServer(1);
  setPlatform({ platform: 1 });
  // setPackExtraOptions({
  //   lpGain: 26,
  //   queueType: 17,
  // });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};
handleDetails();
onNuxtReady(() => {
  setCalculating();
});
watch(
  () => getGamePack,
  (newVal) => {
    setGameAndPack({
      game: getGame.id,
      pack: newVal.id,
      fullGame: getGame,
      fullPack: newVal,
    });
  }
);
</script>
